import { Component,
         Output,
         EventEmitter }             from '@angular/core';
import { TableColumn,
         TableColumnType }          from './../common/table-column';
import { ISortableFilter }          from './../common/sortable-filter';
import { Globals }                  from './../common/globals';
import { Observable }               from 'rxjs/Observable';
import { UserService }              from './../shared/user.service';
import { UserSortableFilter }       from './user-sortable-filter';
import { UserDialogComponent }      from './../user-dialog/user-dialog.component';
import { MatDialog }                 from '@angular/material';
import { SavingDialogComponent }    from './../common/saving-dialog.component';


@Component({
  selector: 'sa-user-list',
  template: require('./user-list.component.html'),
  styles: [require('./user-list.component.scss')]
})
export class UserListComponent {

  @Output() columns: Array<TableColumn>;
  @Output() filter = new UserSortableFilter('ldaplogin');
  @Output() performSearch = new EventEmitter();
  @Output() productUpdated = new EventEmitter();

  public getDataCallback: Function;
  public dataPageCallback: Function;

  public roles: Observable<any>;

  private apiService: UserService;

  constructor(
    apiService: UserService,
    private dialog: MatDialog,
    private globals: Globals
  ) {
    this.apiService = apiService;
    this.getDataCallback = this.getData.bind(this);
    this.dataPageCallback = this.getDataPage.bind(this);
    this.filter.activeOnly = true;
    this.roles = this.apiService.getRoles();

    this.columns = [
      new TableColumn(TableColumnType.Text, 'ldaplogin', 'Login', 130),
      new TableColumn(TableColumnType.Text, 'firstName', 'Jméno', 60),
      new TableColumn(TableColumnType.Text, 'lastName', 'Příjmení', 70),
      new TableColumn(TableColumnType.Text, 'userId', 'UID', 40),
      new TableColumn(TableColumnType.Bool, 'passSet', 'Heslo nastaveno', 40),
      new TableColumn(TableColumnType.Bool, 'forcePwdChange', 'Musí změnit heslo', 40),
      new TableColumn(TableColumnType.Text, 'organization', 'Organizace', 90),
      new TableColumn(TableColumnType.Array, 'roles', 'Role', 80, false, null, null, (val) => { return val.map(r => r.roleName); })
    ];
  }

  private getData(filter: ISortableFilter) {
    return this.apiService.getItems(filter);
  }

  private getDataPage(filter: ISortableFilter) {
    return this.apiService.getItems(filter);
  }

  public search() {
    this.performSearch.emit(this.filter);
  }

  public editItem(model) {
    let dialogRef = this.dialog.open(UserDialogComponent);
    let userTrainRoles = model.roles.filter(r => r.roleName.indexOf('Portal') === -1 && r.roleName.indexOf('Bus') === -1);
    let userBusRoles = model.roles.filter(r => r.roleName.indexOf('Bus') > -1 || r.roleName.indexOf('StockTaking') > -1);
    let userPortalRoles = model.roles.filter(r => r.roleName.indexOf('Portal') > -1);

    let emptyRole = { roleUID: '', roleName: 'Nevybráno' };

    model.userTrainRoleUID = userTrainRoles.length > 0 ? userTrainRoles[0].roleUID : '';
    model.userBusRoleUID = userBusRoles.length > 0 ? userBusRoles[0].roleUID : '';
    model.userPortalRoleUID = userPortalRoles.length > 0 ? userPortalRoles[0].roleUID : '';

    dialogRef.componentInstance.model = model;
    this.roles.subscribe(res => {
      dialogRef.componentInstance.roles = res;
      dialogRef.componentInstance.dataReady = true;
      dialogRef.componentInstance.trainRoles = res.filter(r => r.roleName.indexOf('Portal') === -1 && r.roleName.indexOf('Bus') === -1);
      dialogRef.componentInstance.busRoles = res.filter(r => r.roleName.indexOf('Bus') > -1 || r.roleName.indexOf('StockTaking') > -1);
      dialogRef.componentInstance.portalRoles = res.filter(r => r.roleName.indexOf('Portal') > -1);

      dialogRef.componentInstance.trainRoles.unshift(emptyRole);
      dialogRef.componentInstance.busRoles.unshift(emptyRole);
      dialogRef.componentInstance.portalRoles.unshift(emptyRole);
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        let selectedRoles = dialogRef.componentInstance.roles.filter(r =>
                                      r.roleUID === model.userTrainRoleUID ||
                                      r.roleUID === model.userBusRoleUID ||
                                      r.roleUID === model.userPortalRoleUID);
        dialogRef.componentInstance.model.TnUserRoles = selectedRoles;
        this.apiService.updateItem(dialogRef.componentInstance.model.ldapuserUid, dialogRef.componentInstance.model)
          .subscribe(res => {
            cloakRef.close();
            console.log('User updated');
            this.search();
          });
      } else if (result === 'cancel') {
        this.search();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/user-list/user-list.component.ts